export { default } from './NewsList';
